export { default } from './NewsList';
